module.exports = __webpack_public_path__ + "img/asidebanner.5835cd2a.5835cd2a.jpg";